import React, {useContext} from "react";
import * as Survey from "survey-react";
import SurveyJsComp from "../../common/SurveyJsComp";
import CommentComp from "../../common/CommentComp";
import { AppContext } from "../../../AppContext";

import UserSelectBox from "../../common/controls/UserSelectBox";

import { isLevelFourRaymondJames } from "../../../common/checkClient";
import ChangeSetDisplayComp from "../../common/ChangeSetDisplayComp";

const PreTradeSurveyForm = (props) => {
    const [appContext, setAppContext] = useContext(AppContext);
    const onComplete = (result, options) => {

        let securityType = '';

        const pnlPrivateInvestment = survey.getPanelByName('pnlPrivateInvestment');
        if(pnlPrivateInvestment && pnlPrivateInvestment.isVisible){
            securityType = 'PrivateInvestment';
        }
        
        props.onComplete({ ...props.editorItem, formData: {...result.data, securityType }, changes: changes });
    }
    
    const isLevelFourRJ = isLevelFourRaymondJames();
    const survey = new Survey.Model(props.editorItem.template.templateStr);
    const businessName = survey.getQuestionByName("businessName");
    if (businessName)
        businessName.maxLength = 200;

    const businessType = survey.getQuestionByName("businessType");
    if (businessType)
        businessType.maxLength = 200;

    const businessDesc = survey.getQuestionByName("outsideActivities");
    if (businessDesc)
        businessDesc.maxLength = 500;

    const changes = [];
    const initialData = props.editorItem.formData;
    const handleSurveyChange = (sender, options) => {
        try {
            let oldValue = getOldValue(options.question, options);
            let newValue = getNewValue(options.question, options);
            if (oldValue !== newValue) {
                let change = changes.find(x => x.name == options.name);
                if (change) {
                    change.NewValue = newValue;
                } else {
                    changes.push({
                        PropName: options.question.title,
                        name: options.name,
                        OldValue: oldValue,
                        NewValue: newValue
                    });
                }
            } else {
                changes = changes.filter(x => x.name !== options.name);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const getOldValue = (question, options) => {
        switch (question.getType()) {
            case "file":
                if (initialData[options.name]) {
                    return initialData[options.name].map(x => { return x.name; }).sort().join();
                }
                break;
            default:
                return initialData[options.name] ?? "";
                break;
        }
    }

    const getNewValue = (question, options) => {
        switch (question.getType()) {
            case "file":
                if (options.value) {
                    return options.value.map(x => { return x.name; }).sort().join();
                }
                break;
            default:
                return options.value ?? "";
                break;
        }
    }

    return (<div className="panel-body PreTradeSurveyForm">
        {props.editorMode === 'NEW' && props.editorItem.template.enableOnBehalf && appContext.user.submitOnBehalf && 
            <UserSelectBox name='submittedFor' label='Document in behalf of (optional) : ' onSelected={props.onUserSelected} labelClass='flex-1' controlClass='flex-3'/>
        }
        <SurveyJsComp
            isReadOnly={props.isReadOnly}
            formData={props.editorItem.formData}
            survey={survey}
            onComplete={onComplete} handleCustomValueChange={isLevelFourRJ ? handleSurveyChange : null} />
        { props.isReadOnly && 
            <CommentComp data = {props.data.comments}/>
        }
        {props.isReadOnly && isLevelFourRJ && <ChangeSetDisplayComp changeSet={props.data.changeSet} ignoredProperty="FormData" />}
        </div>);
}

export default PreTradeSurveyForm;